/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ConsentRequest } from './ConsentRequest';
export type CreatePublicServiceConsentRequest = {
  puid?: string;
  category?: CreatePublicServiceConsentRequest.category;
  consentTermsList?: Array<ConsentRequest>;
};
export namespace CreatePublicServiceConsentRequest {
  export enum category {
    VEHICLE_INSPECTION = 'VEHICLE_INSPECTION',
    HIGHWAY_UNPAID = 'HIGHWAY_UNPAID',
    LICENSE_RENEWAL = 'LICENSE_RENEWAL',
    DEMERIT_EDUCATION = 'DEMERIT_EDUCATION',
  }
}

